import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { App } from './App';

// import { ApolloProvider, ApolloClient, InMemoryCache } from '@apollo/client'

// const client = new ApolloClient({
//   uri: `http://localhost:5000/graphql`,
//   cache: new InMemoryCache()
// })

ReactDOM.createRoot(document.getElementById("root")).render(
  // avoid double fetching
  // <React.StrictMode>
    // <ApolloProvider client={client}>
      <App />
    // </ApolloProvider>  
  // </React.StrictMode>
);